import script from "./conferenceDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./conferenceDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./conferenceDetailPage.vue?vue&type=style&index=0&id=7a0d2daa&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a0d2daa"]])

export default __exports__